<template>
	<div>
		<div class="d-flex align-items-center" :class="`${align==='center'? 'just-content-center' : ''}`" v-if="type===0">
			<div :style="company_style">{{ company_name }}</div>
			<div class="d-flex align-items-center popover" v-if="status == 1">
        <el-popover
    placement="top"
    width="150"
    trigger="hover"
    content="云校招实名认证企业">
    <img slot="reference" src="https://weyon-static.oss-cn-shenzhen.aliyuncs.com/campuscloud/public/images/global/realname-icon.png" class="realname-img" />
        </el-popover>
			</div>
		</div>
		<div class="d-flex " v-if="type===1">
      <div class="mr-10" v-if="show_name">{{company_name}}</div>
      <div class="d-flex just-content-center align-items-center company-realname-item" v-if="status == 1">
						  <img src="https://weyon-static.oss-cn-shenzhen.aliyuncs.com/campuscloud/public/images/global/realname-icon.png" class="realname-img ml-0 mr-5" />
						  云校招实名认证企业
              </div>
		</div>
	</div>
</template>

<script>
export default {
  name: "company-name",
  components: {},
  props: {
    type: {
      typeof: Number,
      default: 0
    },
    align: {
      typeof: String,
      default: ""
    },
    show_name: {
      typeof: Boolean,
      default: true
    },
    company_style: {
      typeof: String,
      default: ''
    },
    company_name: {
      typeof: String,
      default: ""
    },
    status: {
      typeof: Number,
      default: -1
    }
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  }
};
</script>

<style lang="scss">
.popover {
  > span {
    > span {
      display: flex;
    }
  }
}
	.company-realname-item{
		padding:0 10px;
		background:#ebebeb;
		border-radius:20px;
		margin-right: 10px;
		font-size:12px;
	}
</style>



// WEBPACK FOOTER //
// src/components/RealName/realname-company-name.vue